<template>
  <div class="bar-chart">
    <GChart ref="gchart" type="BarChart" :data="chartData" :options="chartOptions" />
  </div>
</template>
<script>
import { GChart } from "vue-google-charts"
import { brandColors, generateColorPalette } from "@/lib/colorPalette.js"
export default {
  name: "ChatMessageBar",
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  components: {
    GChart
  },
  computed: {
    metaOptions() {
      try {
        return JSON.parse(this.message.display.meta, this.options)
      } catch {
        return {}
      }
    },
    chartOptions() {
      const defaultOptions = {
        width: 800,
        height: 600,
        colors: this.chartColors
      }
      return Object.assign(this.metaOptions, defaultOptions)
    },
    chartColors() {
      return generateColorPalette(brandColors(), 2)
    },
    chartData() {
      const temp = []

      const data = this.message.data

      if (data.length > 0) {
        temp.push(data[0].map((d) => d.field_name))
        data.map((row) => {
          return temp.push(row.map((f) => f.value))
        })
      }

      console.debug("chartData", temp)

      return temp
    }
  },
  methods: {
    exportChartImage() {
      const g = this.$refs.gchart
      if (!g || !g.chartObject || typeof g.chartObject.getImageURI !== "function") {
        return null
      }
      try {
        return g.chartObject.getImageURI() || null
      } catch (e) {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-container {
  width: 100% !important;
}
</style>